/**
 * @desc 删除全局或基地设置
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 主键id */
  id: number;
}

export function request(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.delete({
    url: '/wap/setting/detail/delete',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.delete({
    url: '/mock/wap/setting/detail/delete',

    params,
  });
}
